import { funnelStep } from './funnel';

/** The part of the build store (state/buildRun.ts) the funnel reads: zustand's subscribe. */
interface WatchableBuild {
  subscribe?: (listener: (now: { status: string }, before: { status: string }) => void) => () => void;
}

/**
 * build_started, build_succeeded and build_failed, read off the build store's own transitions
 * rather than written into it. The store is the browser's longest and most careful piece of code
 * (idempotency keys, recovery, replays); three measurement calls threaded through it would be
 * three more things to keep right in every branch, while its status already says each moment:
 *
 *   - anything → 'running': `start()`, a Try again included. Only `start()` sets it.
 *   - 'running' → 'idle': it landed — the editor opened, or the pill offers it.
 *   - 'running' → 'error': it failed. recover() reporting a build a closed page never heard the
 *     end of goes idle → 'error', which is not counted: that build's start was another page's.
 *
 * Returns the unsubscribe. A store that cannot be watched (a test's stand-in) measures nothing.
 */
export function watchBuildRun(store: WatchableBuild): () => void {
  if (typeof store?.subscribe !== 'function') return () => undefined;
  return store.subscribe((now, before) => {
    if (now.status === before.status) return;
    if (now.status === 'running') funnelStep('build_started');
    else if (before.status === 'running' && now.status === 'idle') funnelStep('build_succeeded');
    else if (before.status === 'running' && now.status === 'error') funnelStep('build_failed');
  });
}
